import { toTitleCase } from '../../utils';
import { formatEpochToDateString } from '../../utils/commonUtils';

// const getReturnLabel = (returnsLabelArr) => {
//   const returnItem = returnsLabelArr.filter((returnObj) => returnObj.value);
//   if (returnItem.length) {
//     return returnItem[0];
//   }
//   return {
//     value: '--',
//     label: 'Returns per yr (5 Year Avg)',
//   };
// };

// const returnHighlights = (returnsLabelArr) => {
//   const { value } = getReturnLabel(returnsLabelArr);
//   // const navDate = new Date(dayEndDate).toDateString().slice(4);
//   return [
//     {
//       image:
//         'https://assets1.cleartax-cdn.com/cleartax/images/1628613984_shape.svg',
//       label: '3 yr CAGR',
//       value: `${value}%`,
//     },
//     // {
//     //   image: 'https://assets1.cleartax-cdn.com/clearsave/images/time_icon.svg',
//     //   label: `NAV as on ${navDate}`,
//     //   value: `${dayEndNav}`,
//     //   navChange,
//     // },
//   ];
// };

const fundDetailsBlock = (props: any) => {
  return (
    <div className="lil-flex lil-flex-wrap lil-items-center">
      {props.risk && (
        <div className="lil-rounded-xxl lil-border-blue-300 lil-border-sm lil-px-4 lil-py-1 lil-mr-2 sm:lil-mr-1 sm:lil-px-2">
          <p className="lil-text-base lil-text-blue-300 sm:lil-text-s-14">
            {toTitleCase(props.risk)}Risk
          </p>
        </div>
      )}

      {props.category && (
        <div className="lil-rounded-xxl lil-border-blue-300 lil-border-sm lil-px-4 lil-py-1 lil-mr-2 sm:lil-mr-1 sm:lil-px-2">
          <p className="lil-text-base lil-text-blue-300 sm:lil-text-s-14">
            {toTitleCase(props.category)}
          </p>
        </div>
      )}

      {!props.isNfo && props.morningStar && Number(props.morningStar) > 0 ? (
        <div className="lil-rounded-xxl lil-border-blue-300 lil-border-sm lil-px-4 lil-py-1 lil-mr-2 sm:lil-mr-1 sm:lil-px-2">
          <p className="lil-text-base lil-text-blue-300 sm:lil-text-s-14">
            {props.morningStar} Star
          </p>
        </div>
      ) : (
        ''
      )}
      {/* {props.purchaseMode && (
        <div className="lil-rounded-xxl lil-border-blue-300 lil-border-sm lil-px-4 lil-py-1 lil-mr-2 sm:lil-mr-1 sm:lil-px-2">
          <p className="lil-text-base lil-text-blue-300 sm:lil-text-s-14">
            {toTitleCase(props.purchaseMode)}
          </p>
        </div>
      )}

      {props.planType && (
        <div className="lil-rounded-xxl lil-border-blue-300 lil-border-sm lil-px-4 lil-py-1 lil-mr-2 sm:lil-mr-1 sm:lil-px-2">
          <p className="lil-text-base lil-text-blue-300  sm:lil-text-s-14">
            {toTitleCase(props.planType)}
          </p>
        </div>
      )} */}

      {/* {props.isElss && props.ELSS ? (
        <div className="lil-rounded-xxl lil-border-blue-300 lil-border-sm lil-px-4 lil-py-1 lil-mr-2 sm:lil-mr-1 sm:lil-px-2">
          <p className="lil-text-base lil-text-blue-300  sm:lil-text-s-14">
            {props.ELSS}
          </p>
        </div>
      ) : null} */}
    </div>
  );
};

const fundFinancialsBlock = (props: any) => {
  return (
    <div className="lil-flex lil-gap-8 sm:lil-flex-col sm:lil-gap-0 sm:lil-items-center lil-w-full">
      <div className="lil-flex-col">
        <div className="lil-text-grey-500 lil-text-s-18">
          NAV as of {formatEpochToDateString(props.navArr.dayEndDate)}
        </div>
        <div className="lil-flex lil-items-baseline">
          <p className="lil-text-black lil-text-s-32">
            ₹{props.navArr.dayEndNav.toFixed(2)}
          </p>
          <p className="lil-text-black lil-text-s-20 lil-font-light">
            <span
              className={`${
                props.navArr.navChangePercent < 0
                  ? 'lil-text-red'
                  : 'lil-text-green-450'
              } lil-px-2 lil-text-s-20`}
            >
              {props.navArr.navChangePercent}%
            </span>
            1D Change
          </p>
        </div>
      </div>

      <div className="lil-flex sm:lil-hidden">
        <div className="lil-border-l-sm lil-border-grey-300 lil-h-full" />
      </div>

      <div className="lil-flex-col">
        <div className="lil-text-grey-500 lil-text-s-18">
          Returns since inception
        </div>
        <p className="lil-text-black lil-text-s-20 lil-font-light">
          <span
            className={`${
              parseFloat(props.returnsSinceInception) < 0
                ? 'lil-text-red'
                : 'lil-text-green-450'
            } lil-px-2 lil-text-s-32 lil-font-medium`}
          >
            {props.returnsSinceInception}%
          </span>
          p.a.
        </p>
      </div>
    </div>
  );
};

const renderTitleSectionWeb = (props: any) => {
  return (
    <div className="lil-container lil-mx-auto lil-px-4">
      <div
        className={`lil-flex lil-pt-12 md:lil-pt-6 sm:lil-pt-4 sm:lil-w-full lil-flex-wrap ${
          !props.isNfo ? '' : ''
        }`}
      >
        {props.imgURL && (
          <div className="lil-w-1/12 sm:lil-w-1/6">
            <img
              className="lil-rounded-md sm:lil-hidden"
              src={`https://assets1.cleartax-cdn.com/clearsave${props.imgURL}`}
              width="80"
            />
            <img
              className="lil-rounded-md md:lil-hidden xl:lil-hidden lg:lil-hidden sm:lil-mt-1"
              src={`https://assets1.cleartax-cdn.com/clearsave${props.imgURL}`}
              width="40"
            />
          </div>
        )}
        <div
          className={`lil-flex lil-flex-wrap lil-w-5/12 lil-pr-4 sm:lil-pl-0 sm:lil-w-5/6 ${
            props.imgURL ? 'lil-pl-6' : 'lil-pl-0'
          }`}
        >
          <h1
            className={`lil-w-full lil-text-s-32 sm:lil-text-s-24 ${
              props.isNfo ? 'lil-pb-4' : 'lil-pb-4 sm:lil-pb-0'
            }`}
          >
            {props.name || props.title}
          </h1>
          <div className="sm:lil-hidden">{fundDetailsBlock(props)}</div>
        </div>
        {!props.isNfo ? (
          <div className="lil-w-6/12 sm:lil-hidden">
            {/* <PlanHighlightsNew data={returnHighlights(props.returnsLabelArr)} /> */}
            {fundFinancialsBlock(props)}
          </div>
        ) : null}
      </div>
      <div className="lil-flex">
        <div className="lil-flex-wrap lil-hidden lil-items-center lil-w-full sm:lil-flex sm:lil-justify-between">
          <div className={`${props.isNfo ? 'lil-pl-12' : ''}`}>
            {fundDetailsBlock(props)}
          </div>
          {!props.isNfo ? (
            <div className="md:lil-hidden xl:lil-hidden lg:lil-hidden">
              {/* <PlanHighlightsNew
                data={returnHighlights(props.returnsLabelArr)}
              /> */}
              {fundFinancialsBlock(props)}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

const fundDetailsBlockMobile = (props: any) => {
  return (
    <div className="lil-flex lil-items-center lil-text-blue-300 lil-text-s-14 lil-mt-1">
      {props.risk && (
        <span className="lil-mr-1">{toTitleCase(props.risk)}Risk</span>
      )}

      {props.risk && props.category && <span className="lil-mx-1">|</span>}

      {props.category && (
        <span className="lil-mr-1">{toTitleCase(props.category)}</span>
      )}

      {props.category &&
        !props.isNfo &&
        props.morningStar &&
        Number(props.morningStar) > 0 && <span className="lil-mx-1">|</span>}

      {!props.isNfo && props.morningStar && Number(props.morningStar) > 0 ? (
        <span className="lil-mr-1">{props.morningStar} Star</span>
      ) : (
        ''
      )}

      {/* {props.isElss && props.ELSS && (
        <div className="lil-flex lil-items-center">
          <span className="lil-mx-1">|</span>
          <span className="lil-mr-1">{props.ELSS}</span>
        </div>
      )} */}
    </div>
  );
};

// const fundFinancialsBlockMobile = (props: any) => {
//   return (
//     <div className="lil-flex lil-justify-center lil-w-full lil-mt-6">
//       <div className="lil-w-3/5 lil-flex lil-flex-col lil-text-left">
//         <div className="lil-text-grey-500 lil-text-s-14">
//           NAV as of {formatEpochToDateString(props.navArr.dayEndDate)}
//         </div>
//         <div className="lil-flex lil-items-baseline lil-mt-1">
//           <p className="lil-text-black lil-text-s-24">
//             ₹{props.navArr.dayEndNav.toFixed(2)}
//           </p>
//           <p className="lil-text-black lil-text-s-14 lil-font-light">
//             <span
//               className={`${
//                 props.navArr.navChangePercent < 0
//                   ? 'lil-text-red'
//                   : 'lil-text-green-450'
//               } lil-px-2 lil-text-s-14`}
//             >
//               {props.navArr.navChangePercent}%
//             </span>
//             1D Change
//           </p>
//         </div>

//         <div className="lil-mt-2">
//           <div className="lil-text-grey-500 lil-text-s-14">
//             Returns since inception
//           </div>
//           <p className="lil-text-black lil-text-s-14 lil-font-light lil-flex lil-items-baseline">
//             <span
//               className={`${
//                 parseFloat(props.returnsSinceInception) < 0
//                   ? 'lil-text-red'
//                   : 'lil-text-green-450'
//               } lil-px-2 lil-text-s-24 lil-font-medium`}
//             >
//               {props.returnsSinceInception}%
//             </span>
//             p.a.
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// };

const fundFinancialsBlockMobile = (props: any) => {
  return (
    <div className="lil-w-full lil-mt-6">
      <div className="lil-flex lil-justify-between">
        <div className="lil-w-1/2 lil-flex lil-justify-center">
          <div className="lil-text-left">
            <div className="lil-text-grey-500 lil-text-s-14">
              NAV as of {formatEpochToDateString(props.navArr.dayEndDate)}
            </div>

            <div className="lil-flex lil-items-baseline lil-mt-1">
              <p className="lil-text-black lil-text-s-24">
                ₹{props.navArr.dayEndNav.toFixed(2)}
              </p>
              <p className="lil-text-black lil-text-s-14 lil-font-light">
                <span
                  className={`${
                    props.navArr.navChangePercent < 0
                      ? 'lil-text-red'
                      : 'lil-text-green-450'
                  } lil-px-2 lil-text-s-14`}
                >
                  {props.navArr.navChangePercent}%
                </span>
                1D
              </p>
            </div>
          </div>
        </div>

        <div className="lil-w-1/2 lil-flex lil-justify-center">
          <div className="lil-text-left">
            <div className="lil-text-grey-500 lil-text-s-14">
              Returns since inception
            </div>
            <p className="lil-text-black lil-text-s-14 lil-font-light lil-flex lil-items-baseline lil-mt-1">
              <span
                className={`${
                  parseFloat(props.returnsSinceInception) < 0
                    ? 'lil-text-red'
                    : 'lil-text-green-450'
                } lil-pr-2 lil-text-s-24 lil-font-medium`}
              >
                {props.returnsSinceInception}%
              </span>
              p.a.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const renderTitleSectionMobile = (props: any) => {
  return (
    <div className="lil-container lil-mx-auto lil-px-4 lil-py-4">
      <div className="lil-flex lil-w-full">
        {props.imgURL && (
          <div className="lil-w-1/6 lil-mr-3">
            <img
              className="lil-rounded-md"
              src={`https://assets1.cleartax-cdn.com/clearsave${props.imgURL}`}
              width="50"
            />
          </div>
        )}

        <div className="lil-flex lil-flex-col lil-w-5/6">
          <h1 className="lil-text-s-24 lil-font-semibold">
            {props.name || props.title}
          </h1>
          {fundDetailsBlockMobile(props)}
        </div>
      </div>

      {/* Financials block stacked vertically */}
      <div className="lil-mt-2 lil-w-full">
        {!props.isNfo ? fundFinancialsBlockMobile(props) : null}
      </div>
    </div>
  );
};

const SingleFundTitleNew = (props: any) => {
  return (
    <div>
      <div className="sm:lil-hidden">{renderTitleSectionWeb(props)}</div>
      <div className="md:lil-hidden lg:lil-hidden xl:lil-hidden">
        {renderTitleSectionMobile(props)}
      </div>
    </div>
  );
};

export default SingleFundTitleNew;



// WEBPACK FOOTER //
// ./components/singleFund/singleFundTitleNew.tsx